import { UserHelper } from '..';

export const useUser = () => {
	let userHelper = new UserHelper();

	//Todo: check if user is for the same event.

	return { userHelper, activeUser: userHelper.active() };
};
